"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataPropDesc_1 = require("./DataPropDesc");

var ObjectPropDesc =
/*#__PURE__*/
function (_DataPropDesc_1$DataP) {
  _inherits(ObjectPropDesc, _DataPropDesc_1$DataP);

  function ObjectPropDesc(data, parser, description, validators) {
    _classCallCheck(this, ObjectPropDesc);

    return _possibleConstructorReturn(this, _getPrototypeOf(ObjectPropDesc).call(this, data, parser, description, validators));
  }

  _createClass(ObjectPropDesc, [{
    key: "withMappedParser",
    value: function withMappedParser(spec, mapping) {
      throw new Error('Parser mapping not supported');
    }
  }, {
    key: "withDescription",
    value: function withDescription(descr) {
      return new ObjectPropDesc(this.data, this.parser, this.mergeDescs(descr), this.validators);
    }
  }, {
    key: "acceptVisitor",
    value: function acceptVisitor(visitor) {
      return visitor.visitObject(this);
    }
  }, {
    key: "data",
    get: function get() {
      return _get(_getPrototypeOf(ObjectPropDesc.prototype), "data", this);
    }
  }]);

  return ObjectPropDesc;
}(DataPropDesc_1.DataPropDesc);

exports.ObjectPropDesc = ObjectPropDesc;